<template>
    <div class="container-fluid">
        <div class="row centro justify-content-center">
            <div class="col-md-10 align-self-center">
                <div class="form-box mx-auto box-cadastro">
                    <div class="row justify-content-center">
                        <div class="col-md-5 align-self-center text-center">
                            <img src="../assets/logo.png" alt="Editora do Brasil" class="img-fluid mx-auto d-block">
                        </div>
                    </div>
                    <h2>Cadastre-se</h2>
                    <form id="formCadastro" @submit.prevent="register">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="Nome" class="label">Nome completo</label>
                                    <div class="input-group">
                                        <input id="Nome" type="text" v-model="$v.user.Nome.$model" class="form-control" maxlength="100">
                                    </div>
                                    <p v-if="errors" class="error">
                                        <span v-if="!$v.user.Nome.required">Preencha este campo, por favor.</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label">Nome do responsável</label>
                                    <div class="input-group">
                                        <input type="text" v-model="$v.user.Responsavel.$model" class="form-control" maxlength="100">
                                    </div>
                                    <p v-if="errors" class="error">
                                        <span v-if="!$v.user.Responsavel.required">Preencha este campo, por favor.</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="label">E-mail</label>
                            <div class="input-group">
                                <input type="email" v-model="$v.user.Email.$model" class="form-control" maxlength="100">
                            </div>
                            <p v-if="errors" class="error">
                                <span v-if="!$v.user.Email.required">Preencha este campo, por favor.</span>
                                <span v-if="!$v.user.Email.email">Preencha um E-mail válido, por favor.</span>
                            </p>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="IdUf">UF</label>
                                    <select id="IdUf" v-model.number="$v.user.IdUf.$model" @change="getCidades()" class="form-control">
                                        <option value="null">Selecione...</option>
                                        <option v-for="estado in estados" :key="estado" :value="estado">{{ estado }}</option>
                                    </select>
                                    <p v-if="errors" class="error">
                                        <span v-if="!$v.user.IdUf.required">Selecione uma opção, por favor.</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="IdCidade">Cidade</label>
                                    <select id="IdCidade" v-model.number="$v.user.IdCidade.$model" @change="getEscolas()" class="form-control">
                                        <option value="null">Selecione...</option>
                                        <option v-for="cidade in cidades" :key="cidade" :value="cidade">{{ cidade }}</option>
                                    </select>
                                    <p v-if="errors" class="error">
                                        <span v-if="!$v.user.IdCidade.required">Selecione uma opção, por favor.</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="IdEscola">Escola</label>
                                    <select id="IdEscola" v-model.number="$v.user.IdEscola.$model" class="form-control">
                                        <option value="null">Selecione...</option>
                                        <option v-for="escola in escolas" :key="escola.idEscola" :value="escola.idEscola">{{ escola.nome }}</option>
                                    </select>
                                    <p v-if="errors" class="error">
                                        <span v-if="!$v.user.IdEscola.required">Selecione uma opção, por favor.</span>
                                    </p>
                                </div>
                            </div>
                            <!-- <div class="col-md-3">
                                <div class="form-group">
                                    <label for="IdSerie">Ano*</label>
                                    <select id="IdSerie" v-model.number="user.IdSerie" class="form-control">
                                        <option value="null">Selecione...</option>
                                        <option v-for="serie in series" :key="serie.id" :value="serie.id">{{ serie.nome }}</option>
                                    </select>
                                    <p v-if="selSerie" class="error">
                                        <span>Selecione uma opção, por favor!</span>
                                    </p>
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="pass1" class="label">Senha</label>
                                    <div class="input-group">
                                        <input id="pass1" type="password" v-model="$v.user.Senha.$model" class="form-control" maxlength="250">
                                    </div>
                                    <p v-if="errors" class="error">
                                        <span v-if="!$v.user.Senha.required">Preencha este campo, por favor. </span>
                                        <span v-if="!$v.user.Senha.strongPassword">Sua senha precisa ter uma letra, um número, um caractere especial e ter mais de 8 caracteres.</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="pass2" class="label">Confirmar senha</label>
                                    <div class="input-group">
                                        <input id="pass2" type="password" v-model="$v.user.ConfirmarSenha.$model" class="form-control" maxlength="250">
                                    </div>
                                    <p v-if="errors" class="error">
                                        <span v-if="!$v.user.ConfirmarSenha.required">Preencha este campo, por favor. </span>
                                        <span v-if="!$v.user.ConfirmarSenha.sameAsPassword">As senhas são diferentes.</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-20">
                            <!-- <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label"><b>*Obrigatório o preenchimento</b></label>
                                </div>
                            </div> -->
                            <div class="col-md-12">
                                <div class="form-group text-right">
                                    <router-link to="/" class="btn btn-recuperar" style="margin-right: 15px">Voltar</router-link>
                                    <button @click.prevent="register" class="btn btn-submit">Cadastrar</button>
                                </div>
                            </div>
                            <div class="col">
                                <div v-if="errors" class="alert alert-danger fade show" role="alert">
                                    O formulário contém erros, corrija e tente novamente.
                                </div>
                                <div v-else-if="formTouched && uiState === 'submit clicked'" class="alert alert-danger fade show" role="alert">
                                    Preencha todos os campos.
                                </div>
                                <div v-else-if="uiState === 'form submitted'" class="alert alert-success fade show" role="alert">
                                    Cadastro efetuado com sucesso. Verifique seu email.<br>Você será redirecionado a página inicial.
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {http} from '../services/APIservice'
import { required, email, sameAs } from 'vuelidate/lib/validators'

export default {
    name: 'cadastro',
    data() {
        return {
            headers: {
                'Access-Control-Allow-Origin': '*'
            },
            //Arrays para popular combos
            estados: [],
            cidades: [],
            escolas: [],
            //series: [],
            //Sets para validação
            uiState: "submit not clicked",
            formTouched: false,
            errors: false,
            empty: true,
            //Envio de form POST para API
            user: {
                Nome: '',
                Responsavel: '',
                Email: '',
                Senha: null,
                ConfirmarSenha: null,
                IdUf: null,
                IdCidade: null,
                IdEscola: null,
                //IdSerie: null
            }
        }
    },
    //Validação de formulario
    validations: {
        user: {
            Nome: { required },
            Responsavel: { required },
            Email: { 
                required,
                email 
            },
            IdUf: { required },
            IdCidade: { required },
            IdEscola: { required },
            Senha: {
                required,
                strongPassword(Senha) {
                    return (
                        /[a-z]/.test(Senha) && // checks for a-z
                        /[0-9]/.test(Senha) && // checks for 0-9
                        /\W|_/.test(Senha) && // checks for special char
                        Senha.length >= 8
                    );
                }
            },
            ConfirmarSenha: {
                required,
                sameAsPassword: sameAs("Senha")
            }
        }
    },
    methods: {
        //função popula combo estados
        async getEstados () {
            await http.get('Escola/ListarEstados')
                .then(res => {
                    //console.log(res)
                    this.estados = [...res.data]
                })
                .catch(err => {
                    console.log(err)
                })
        },
        //função popula combo cidades
        getCidades (uf) {
            uf = this.user.IdUf
            return http.get(`Escola/ListarCidades?uf=${uf}`)
                .then(res => {
                    //console.log(res)
                    this.cidades = [...res.data]
                })
                .catch(err => {
                    console.log(err)
                })
        },
        //função popula combo escolas
        getEscolas (uf, city) {
            uf = this.user.IdUf
            city = this.user.IdCidade
            // console.log(uf);
            // console.log(this.user.IdCidade);
            return http.get(`Escola/ListarEscolas?uf=${uf}&cidade=${city}`)
                .then(res => {
                    //console.log(res)
                    this.escolas = [...res.data]
                })
                .catch(err => {
                    console.log(err)
                })
        },
        //função popula combo series
        // getSeries (escola) {
        //     escola = this.user.IdEscola
        //     console.log(escola);
        //     return http.get(`Serie?idEscola=${escola}`)
        //         .then(res => {
        //             console.log(res)
        //             this.series = [...res.data]
        //         })
        //         .catch(err => {
        //             console.log(err)
        //         })
        // },
        //Função checa form, se estiver OK envia pra API
        register() {
            this.formTouched = !this.$v.user.$anyDirty;
            this.errors = this.$v.user.$anyError;
            this.uiState = "submit clicked";

            if (this.user.ConfirmarSenha === null) {
                this.errors = true
            }

            if (this.errors === false && this.formTouched === false && this.user.ConfirmarSenha != null) {
                //this is where you send the responses
                this.uiState = "form submitted";
                //console.log(this.uiState);
                return http.post('Usuario/', this.user, {
                    headers: this.headers
                })
                .then(response => {
                    //console.log(response);
                    //console.log(response.status);

                    if (response.status == 200) {
                    setTimeout(() => {
                        var url = window.location.origin;
                        window.location.href = url;
                    }, 5000);
                }
                })
                .catch(error => {
                    console.log(error)
                });
            }
        }
    },
    created () {
        this.getEstados()
    }
}
</script>
